module.exports = __webpack_public_path__ + "img/471.b96c15fe.jpg";